import { useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { useAuth } from './AuthContext';

export default function LoginPage() {
  const { login, loginError } = useAuth();
  const navigate = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const success = await login(username, password);
    setLoading(false);
    if (success) navigate('/chart');
  };

  return (
    <div style={{
      display: 'flex', alignItems: 'center', justifyContent: 'center',
      minHeight: '100vh', background: '#0a0e1a',
    }}>
      <form onSubmit={handleSubmit} style={{
        background: '#1a1f2e', padding: '2rem', borderRadius: '8px',
        width: '320px', display: 'flex', flexDirection: 'column', gap: '1rem',
        border: '1px solid #2a3344',
      }}>
        <h2 style={{ color: '#e2e8f0', margin: 0, textAlign: 'center' }}>Login</h2>

        {loginError && (
          <div style={{
            color: '#f87171', background: '#1c1017', padding: '0.5rem',
            borderRadius: '4px', fontSize: '0.875rem', textAlign: 'center',
          }}>
            {loginError}
          </div>
        )}

        <input
          type="text"
          placeholder="Username"
          value={username}
          onChange={(e) => setUsername(e.target.value)}
          autoFocus
          style={{
            background: '#0a0e1a', color: '#e2e8f0', border: '1px solid #2a3344',
            borderRadius: '4px', padding: '0.625rem', fontSize: '0.875rem',
            outline: 'none',
          }}
        />

        <input
          type="password"
          placeholder="Password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          style={{
            background: '#0a0e1a', color: '#e2e8f0', border: '1px solid #2a3344',
            borderRadius: '4px', padding: '0.625rem', fontSize: '0.875rem',
            outline: 'none',
          }}
        />

        <button
          type="submit"
          disabled={loading || !username || !password}
          style={{
            background: loading ? '#2a3344' : '#3b82f6', color: '#fff',
            border: 'none', borderRadius: '4px', padding: '0.625rem',
            fontSize: '0.875rem', cursor: loading ? 'wait' : 'pointer',
            fontWeight: 600,
          }}
        >
          {loading ? 'Signing in...' : 'Sign in'}
        </button>

        <Link to="/" style={{
          color: '#64748b', fontSize: '0.8rem', textAlign: 'center',
          textDecoration: 'none',
        }}>
          Back to home
        </Link>
      </form>
    </div>
  );
}
